export const NOT_SUPPORTED: GeolocationPositionError = {
	code: 2,
	message: "Geolocation is not supported",
	PERMISSION_DENIED: 1,
	POSITION_UNAVAILABLE: 2,
	TIMEOUT: 3,
};

export const POSITION_OPTIONS: PositionOptions = {
	timeout: 60000,
	enableHighAccuracy: true,
};
